import React, { useState, useEffect } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Table } from 'reactstrap';
import { Link } from 'react-router-dom';
import { useAlert } from 'hooks';
import AlertModal from 'components/AlertModal';
import {
  getAllSolicitudesFacturacionOOSS,
} from '../../features/facturacionooss/facturacionoossAPI';
import {
  FacturacionOOSSRequest,
} from 'types/FacturacionOOSS';

export default function ListConsultorios() {
  const [solicitudes, setSolicitudes] = useState<FacturacionOOSSRequest[]>([]);

  const [showAlert, message, alert] = useAlert(false, '');

  useEffect(() => {
    getAllSolicitudesFacturacionOOSS()
      .then(response => {
        setSolicitudes(response);
      })
      .catch(err => {
        alert(
          true,
          err.getMessage() || 'No se puedieron obtener las solicitudes de facturación en OOSS del matriculado',
        );
      });
  }, []);

  return (
    <div className="content">
      <AlertModal
        isOpen={showAlert}
        message={message}
        onClose={() => alert(false)}
      />
      <Row>
        <Col md={12}>
          <Card>
            <CardHeader>
              <Row>
                <Col md={8} style={{ fontSize: '1.5rem', marginTop: '10px' }}>
                  Solicitudes de Alta de Facturación en OOSS
                </Col>
                <Col md={4} className="text-right">
                  <Link
                    to={{ pathname: '/facturacion-ooss/create' }}
                    className="btn btn-primary btn-round"
                  >
                    Nuevo Alta
                  </Link>
                </Col>
              </Row>
            </CardHeader>
            <CardBody>
              <Table>
                <thead>
                  <tr>
                    <th>Número RNP</th>
                    <th>Prestador OOSS</th>
                    <th>Prestador IOMA</th>
                    <th>Estado</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    solicitudes.map(row => (
                      <tr key={ `row_${ row.id }` }>
                        <td>{ row.numero_rnp ?? '' }</td>
                        <td>{ row.prestador_os ? 'Sí' : 'No' }</td>
                        <td>{ row.prestador_ioma ? 'Sí' : 'No' }</td>
                        <td>{ row.state?.name }</td>
                        <td>
                          { [3].includes(row.state?.id || 0)
                            ?
                              <Link
                                to={`/facturacion-ooss/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Editar'
                              >
                                <i className="fa fa-edit"></i>
                              </Link>
                            :
                              <Link
                                to={`/facturacion-ooss/${ row.id }/edit`}
                                className="btn btn-round btn-primary btn-sm"
                                title='Ver'
                              >
                                <i className="fa fa-eye"></i>
                              </Link>
                          }
                        </td>
                      </tr>
                    ))
                  }
                </tbody>
              </Table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
